import AppStoreSocialBtn from "@/assets/icons/svgs/app-store-social-btn.svg";
import GooglePlaySocialBtn from "@/assets/icons/svgs/google-play-social-btn.svg";
import { WhatsappSupportBannerBall } from "@/components/shared/whatsapp-support-banner";
import { onChatSales } from "@/lib/chat-sales";
import { Link } from "@/components/shared/link";
import { Typography } from "@/components/shared/typography";
import { Image, View } from "@/components/ui";
import { links } from "@/constants";
import { sendAnalyticData } from "@/lib/monitoring/analytics";
import { handleOpenLink } from "@/lib/platform";
import Lottie from "lottie-react";
import iphoneMockAnimation from "@/assets/lottie/iphone-mockup-animation.json";
import StarIconCTA from "@/assets/images/star-icon-xs-cta.png";
import StarIconLarge from "@/assets/images/star-icon-large.png";
import StarIconMedium from "@/assets/images/star-icon-medium.png";

export const DownloadAppPage = () => {
  const sendToRudderStack = async (href: string) => {
    await handleOpenLink(href);
    sendAnalyticData({
      name: "app_download_button_click",
      values: {
        button_location: href,
      },
    });
  };

  return (
    <View className="relative flex h-[calc(100vh-64px)] flex-col items-center gap-2 overflow-y-auto overflow-x-hidden pt-9">
      <View className="relative overflow-hidden">
        <Image src={StarIconMedium} className="absolute -left-[17%] top-0" />
        <Image src={StarIconLarge} className="absolute -right-[30%] bottom-0" />
        <Image
          src={StarIconLarge}
          className="absolute -bottom-[17%] -left-[28%]"
        />
      </View>
      <View className="relative flex flex-col items-center gap-4">
        <Image src={StarIconCTA} className="absolute -top-4 left-5" />
        <Typography
          variant="label-lg"
          className="max-w-[320px]"
          align="center"
          color="brand-static"
        >
          Get the help you need at your fingertips
        </Typography>

        <View className="flex flex-row gap-4">
          <View>
            <Typography variant="caption-md" color="brand-static">
              👥 17,000+
            </Typography>
            <Typography variant="caption-md" color="brand-static">
              Customers Served
            </Typography>
          </View>

          <View>
            <Typography variant="caption-md" color="brand-static">
              📆 320,000+
            </Typography>
            <Typography variant="caption-md" color="brand-static">
              Sessions Completed
            </Typography>
          </View>

          <View>
            <Typography variant="caption-md" color="brand-static">
              ⭐ 4.9* (1000+)
            </Typography>
            <Typography variant="caption-md" color="brand-static">
              Google Reviews
            </Typography>
          </View>
        </View>
        <Image src={StarIconCTA} className="absolute -bottom-3 -right-1" />
      </View>

      <Lottie
        animationData={iphoneMockAnimation}
        loop={true}
        autoplay={true}
        className="-mb-6 mt-9 w-full max-w-[560px]"
      />
      <Typography
        variant="label-lg"
        className="max-w-[320px]"
        align="center"
        color="brand-static"
      >
        Get the app now!
      </Typography>
      <View className="flex gap-2">
        <View
          onClick={() => sendToRudderStack(links.appStoreClientApp)}
          className="cursor-pointer rounded-full border border-primary-border bg-primary-surface px-4 py-2"
        >
          <Image src={AppStoreSocialBtn} />
        </View>
        <View
          onClick={() => sendToRudderStack(links.googlePlayClientApp)}
          className="cursor-pointer rounded-full border border-primary-border bg-primary-surface px-4 py-2"
        >
          <Image src={GooglePlaySocialBtn} />
        </View>
      </View>

      <View className="mt-auto pb-4">
        <Typography variant="body-md" align="center" color="brand-static">
          Need a help?{" "}
          <Link target="_blank" href={links.helpCenter}>
            <Typography
              as="span"
              variant="body-md"
              className="underline"
              color="brand-static"
            >
              Visit our Help Center
            </Typography>
          </Link>
        </Typography>
      </View>
      <View className="fixed bottom-0 right-0">
        <WhatsappSupportBannerBall onClick={() => onChatSales(true)} />
      </View>
    </View>
  );
};
